/* Vinami wijnquiz (sections/vn-quiz.liquid). Geen afhankelijkheden. */
(function () {
  var root = document.querySelector('[data-vn-quiz]');
  if (!root) return;

  function $(sel, el) { return (el || root).querySelector(sel); }
  function $$(sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); }
  function parse(sel) { try { return JSON.parse($(sel).textContent); } catch (e) { return null; } }
  function shuffle(a) { a = a.slice(); for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = a[i]; a[i] = a[j]; a[j] = t; } return a; }
  function el(tag, attrs, text) {
    var n = document.createElement(tag);
    for (var k in attrs || {}) { if (k === 'class') n.className = attrs[k]; else n.setAttribute(k, attrs[k]); }
    if (text != null) n.textContent = text;
    return n;
  }
  var SVGNS = 'http://www.w3.org/2000/svg';
  function svg(tag, attrs) { var n = document.createElementNS(SVGNS, tag); for (var k in attrs) n.setAttribute(k, attrs[k]); return n; }

  var questions = parse('[data-quiz-questions]') || [];
  var maps = parse('[data-quiz-maps]') || {};
  var cfg = $('[data-quiz-config]').dataset;
  var names = (cfg.names || '').split('|');
  var perRound = parseInt(cfg.perRound, 10) || 10;
  var rewardLevel = parseInt(cfg.rewardLevel, 10) || 4;
  var LETTERS = ['A', 'B', 'C', 'D', 'E', 'F'];
  var TYPE_LABEL = { meerkeuze: 'Kies het goede antwoord', waar_niet_waar: 'Waar of niet waar?', volgorde: 'Zet op volgorde', kaart: 'Tik op de kaart' };

  var store = {
    get: function (k, d) { try { var v = localStorage.getItem(k); return v ? JSON.parse(v) : d; } catch (e) { return d; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };

  var state = { level: 1, round: [], i: 0, score: 0, wrong: [], answered: false };

  function show(name) {
    $$('[data-screen]').forEach(function (s) { s.hidden = s.dataset.screen !== name; });
    var top = root.getBoundingClientRect().top + window.scrollY - 90;
    if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'smooth' });
  }

  function renderBest() {
    var best = store.get('vnQuizBest', {});
    $$('[data-best]').forEach(function (b) {
      var v = best[b.dataset.best];
      b.hidden = v == null;
      if (v != null) b.textContent = 'Jouw beste: ' + v.s + ' / ' + v.t;
    });
  }

  function start(level) {
    state.level = level;
    var pool = questions.filter(function (q) { return q.n === level; });
    state.round = shuffle(pool).slice(0, perRound);
    state.i = 0; state.score = 0; state.wrong = [];
    if (!state.round.length) {
      alert('Voor dit niveau staan nog geen vragen klaar.');
      return;
    }
    $('[data-level-tag]').textContent = names[level - 1] || ('Niveau ' + level);
    show('play');
    ask();
  }

  // ---------- Vragen ----------
  function ask() {
    var q = state.round[state.i];
    state.answered = false;
    $('[data-count]').textContent = 'Vraag ' + (state.i + 1) + ' van ' + state.round.length;
    $('[data-progress]').style.width = (state.i / state.round.length * 100) + '%';
    $('[data-type]').textContent = TYPE_LABEL[q.t] || '';
    var h = $('[data-question]');
    h.textContent = q.q;
    var box = $('[data-answers]');
    box.innerHTML = '';
    $('[data-feedback]').hidden = true;
    $('[data-next]').hidden = true;
    $('[data-check]').hidden = true;
    if (q.t === 'waar_niet_waar') renderTF(q, box);
    else if (q.t === 'volgorde') renderOrder(q, box);
    else if (q.t === 'kaart' && maps[q.m]) renderMap(q, box);
    else renderMC(q, box);
    if (state.i > 0) h.focus({ preventScroll: true });
  }

  function renderMC(q, box) {
    var opts = q.a.map(function (text, idx) { return { text: q.t === 'kaart' ? text.split('|')[0] : text, right: idx + 1 === q.c }; });
    opts = shuffle(opts);
    var ul = el('ul', { class: 'vn-quiz__opts' });
    opts.forEach(function (o, k) {
      var b = el('button', { type: 'button', class: 'vn-quiz__opt' });
      b.appendChild(el('span', { class: 'vn-quiz__key', 'aria-hidden': 'true' }, LETTERS[k]));
      b.appendChild(el('span', {}, o.text));
      b.addEventListener('click', function () {
        if (state.answered) return;
        $$('.vn-quiz__opt', ul).forEach(function (x, n) { x.disabled = true; if (opts[n].right) x.classList.add('is-right'); });
        if (!o.right) b.classList.add('is-wrong');
        var right = opts.filter(function (x) { return x.right; })[0];
        finish(o.right, right ? right.text : '');
      });
      var li = el('li'); li.appendChild(b); ul.appendChild(li);
    });
    box.appendChild(ul);
  }

  function renderTF(q, box) {
    var ul = el('ul', { class: 'vn-quiz__opts vn-quiz__tf' });
    ['Waar', 'Niet waar'].forEach(function (label, idx) {
      var b = el('button', { type: 'button', class: 'vn-quiz__opt' }, label);
      b.addEventListener('click', function () {
        if (state.answered) return;
        var right = idx + 1 === q.c;
        $$('.vn-quiz__opt', ul).forEach(function (x, n) { x.disabled = true; if (n + 1 === q.c) x.classList.add('is-right'); });
        if (!right) b.classList.add('is-wrong');
        finish(right, q.c === 1 ? 'Waar' : 'Niet waar');
      });
      var li = el('li'); li.appendChild(b); ul.appendChild(li);
    });
    box.appendChild(ul);
  }

  function renderOrder(q, box) {
    var picked = [];
    box.appendChild(el('p', { class: 'vn-quiz__hint' }, 'Tik de antwoorden aan in de goede volgorde. Tik op een vak om het terug te zetten.'));
    var slots = el('div', { class: 'vn-quiz__order-slots' });
    var chips = el('div', { class: 'vn-quiz__chips' });
    q.a.forEach(function () { slots.appendChild(el('div', { class: 'vn-quiz__slot' })); });
    var shuffled = shuffle(q.a);
    if (shuffled.join('|') === q.a.join('|')) shuffled = shuffled.slice().reverse();
    shuffled.forEach(function (text) {
      var c = el('button', { type: 'button', class: 'vn-quiz__chip' }, text);
      c.addEventListener('click', function () { if (state.answered) return; picked.push(text); c.disabled = true; paint(); });
      chips.appendChild(c);
    });
    function paint() {
      $$('.vn-quiz__slot', slots).forEach(function (s, n) {
        s.textContent = picked[n] || '';
        s.classList.toggle('is-filled', !!picked[n]);
        s.setAttribute('role', picked[n] ? 'button' : 'presentation');
        s.tabIndex = picked[n] ? 0 : -1;
      });
      $('[data-check]').hidden = picked.length !== q.a.length;
    }
    slots.addEventListener('click', function (e) {
      if (state.answered) return;
      var s = e.target.closest('.vn-quiz__slot'); if (!s) return;
      var n = $$('.vn-quiz__slot', slots).indexOf(s); if (!picked[n]) return;
      var text = picked.splice(n, 1)[0];
      $$('.vn-quiz__chip', chips).forEach(function (c) { if (c.textContent === text) c.disabled = false; });
      paint();
    });
    slots.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); e.target.click(); } });
    box.appendChild(slots); box.appendChild(chips);
    var check = $('[data-check]');
    check.onclick = function () {
      if (state.answered) return;
      var ok = true;
      $$('.vn-quiz__slot', slots).forEach(function (s, n) {
        var good = picked[n] === q.a[n];
        if (!good) { ok = false; s.appendChild(el('small', {}, q.a[n])); }
        s.classList.add(good ? 'is-right' : 'is-wrong');
        s.removeAttribute('role'); s.tabIndex = -1;
      });
      $$('.vn-quiz__chip', chips).forEach(function (c) { c.disabled = true; });
      check.hidden = true;
      finish(ok, q.a.join(', '));
    };
  }

  function renderMap(q, box) {
    var m = maps[q.m];
    var wrap = el('div', { class: 'vn-quiz__map' });
    var opts = shuffle(q.a.map(function (a, idx) {
      var p = a.split('|');
      return { name: p[0], x: parseFloat(p[2]) * m.ax + m.bx, y: parseFloat(p[1]) * m.ay + m.by, right: idx + 1 === q.c };
    }));
    // Inzoomen op de punten: vierkant uitsnede met ruimte eromheen, binnen de kaart van 600 x 600
    var xs = opts.map(function (o) { return o.x; }), ys = opts.map(function (o) { return o.y; });
    var minX = Math.min.apply(null, xs), maxX = Math.max.apply(null, xs), minY = Math.min.apply(null, ys), maxY = Math.max.apply(null, ys);
    var size = Math.min(600, Math.max(260, maxX - minX + 200, maxY - minY + 160));
    var vx = Math.max(0, Math.min(600 - size, (minX + maxX) / 2 - size / 2));
    var vy = Math.max(0, Math.min(600 - size, (minY + maxY) / 2 - size / 2));
    var k = size / 600;
    var s = svg('svg', { viewBox: [vx, vy, size, size].map(function (v) { return Math.round(v); }).join(' '), role: 'group', 'aria-label': 'Kaart met ' + q.a.length + ' punten' });
    s.appendChild(svg('image', { href: m.src, width: 600, height: 600 }));
    var dots = [];
    opts.forEach(function (o, n0) {
      var g = svg('g', { class: 'vn-quiz__dot', tabindex: 0, role: 'button', 'aria-label': 'Punt ' + LETTERS[n0] });
      g.appendChild(svg('circle', { cx: o.x, cy: o.y, r: 15 * k, 'stroke-width': 3 * k }));
      var t = svg('text', { x: o.x, y: o.y, 'font-size': 15 * k }); t.textContent = LETTERS[n0]; g.appendChild(t);
      function pick() {
        if (state.answered) return;
        dots.forEach(function (d, n) {
          if (opts[n].right) d.classList.add('is-right');
          var flip = opts[n].x > vx + size * 0.62;
          var lbl = svg('text', { x: opts[n].x + (flip ? -22 : 22) * k, y: opts[n].y, class: 'vn-quiz__dot-name', 'font-size': 15 * k, 'stroke-width': 4 * k });
          if (flip) lbl.setAttribute('style', 'text-anchor:end');
          lbl.textContent = opts[n].name.toUpperCase(); d.appendChild(lbl);
          d.removeAttribute('tabindex');
        });
        if (!o.right) g.classList.add('is-wrong');
        var right = opts.filter(function (x) { return x.right; })[0];
        finish(o.right, right ? right.name : '');
      }
      g.addEventListener('click', pick);
      g.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); } });
      s.appendChild(g); dots.push(g);
    });
    wrap.appendChild(s); box.appendChild(wrap);
  }

  function finish(right, answerText) {
    state.answered = true;
    var q = state.round[state.i];
    if (right) state.score++;
    else state.wrong.push({ q: q.q, a: answerText });
    var fb = $('[data-feedback]');
    fb.className = 'vn-quiz__feedback ' + (right ? 'is-right' : 'is-wrong');
    fb.innerHTML = '';
    fb.appendChild(el('strong', {}, right ? 'Goed zo.' : 'Helaas. Het goede antwoord: ' + answerText + '.'));
    if (q.e) fb.appendChild(el('span', {}, q.e + ' '));
    if (q.l) fb.appendChild(el('a', { href: q.l }, q.ll || 'Lees meer'));
    fb.hidden = false;
    var next = $('[data-next]');
    next.textContent = state.i + 1 < state.round.length ? 'Volgende vraag' : 'Bekijk je score';
    next.hidden = false;
    $('[data-progress]').style.width = ((state.i + 1) / state.round.length * 100) + '%';
    next.focus({ preventScroll: true });
  }

  // ---------- Uitslag ----------
  function result() {
    var total = state.round.length, sc = state.score, r = sc / total, lvl = state.level;
    var name = names[lvl - 1] || ('Niveau ' + lvl);
    var bubble, verdict;
    if (r === 1) { bubble = 'Deze mag op de lijst.'; verdict = 'Foutloos. Daar kan menig sommelier een puntje aan zuigen.'; }
    else if (r >= 0.8) { bubble = 'Proost, dat zit goed.'; verdict = 'Sterk. Je weet waar je het over hebt.'; }
    else if (r >= 0.6) { bubble = 'Netjes.'; verdict = 'Een mooie score, met een paar fouten die je nu niet meer maakt.'; }
    else if (r >= 0.4) { bubble = 'Nog een glaasje?'; verdict = 'Half goed. De vragen wisselen, dus probeer het gerust nog eens.'; }
    else { bubble = 'Eerst even proeven?'; verdict = 'Dat was pittig. Lees de uitleg hieronder en probeer het nog eens.'; }
    if (lvl === 4 && r < 0.6) verdict += ' ' + name + ' is ook echt lastig.';

    $('[data-bubble]').textContent = bubble;
    $('[data-result-level]').textContent = name;
    $('[data-score]').textContent = sc;
    $('[data-total]').textContent = total;
    $('[data-verdict]').textContent = verdict;

    var best = store.get('vnQuizBest', {});
    if (!best[lvl] || sc / total > best[lvl].s / best[lvl].t) { best[lvl] = { s: sc, t: total }; store.set('vnQuizBest', best); }
    renderBest();

    var nl = $('[data-next-level]');
    var hasNext = lvl < 4 && r >= 0.7 && questions.some(function (q) { return q.n === lvl + 1; });
    nl.hidden = !hasNext;
    if (hasNext) { nl.textContent = 'Door naar ' + (names[lvl] || 'niveau ' + (lvl + 1)); nl.onclick = function () { start(lvl + 1); }; }

    var rv = $('[data-review]'), list = $('[data-review-list]');
    list.innerHTML = '';
    state.wrong.forEach(function (w) { var li = el('li', {}, w.q); li.appendChild(el('span', {}, 'Goed antwoord: ' + w.a)); list.appendChild(li); });
    rv.hidden = !state.wrong.length;

    $$('[data-recs]').forEach(function (b) { b.hidden = b.dataset.recs !== String(lvl); });

    var text = (cfg.shareText || '').replace('[score]', sc).replace('[totaal]', total).replace('[niveau]', name) + ' ' + cfg.url;
    $('[data-share]').href = 'https://wa.me/?text=' + encodeURIComponent(text);

    var min = Math.min(parseInt(cfg.rewardMin, 10) || 9, total);
    var reward = $('[data-reward]');
    reward.hidden = !(lvl === rewardLevel && sc >= min);
    if (!reward.hidden) {
      var code = store.get('vnQuizCode', null);
      if (!code) { code = 'VINO-' + (Date.now() % 1679616).toString(36).toUpperCase() + Math.random().toString(36).slice(2, 5).toUpperCase(); store.set('vnQuizCode', code); }
      $('[data-code]').textContent = code;
      $('[data-reward-done]').hidden = true;
      $('[data-reward-cart]').hidden = false;
      $('[data-reward-cart]').onclick = function () {
        var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        fetch(rootUrl + 'cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { 'Verrassingsfles (quiz)': code + ' · ' + name + ' ' + sc + '/' + total } })
        }).then(function (res) {
          if (!res.ok) throw new Error();
          $('[data-reward-cart]').hidden = true;
          $('[data-reward-done]').hidden = false;
        }).catch(function () { alert('Dat lukte niet. Zet de code in het opmerkingenveld van je bestelling.'); });
      };
    }
    show('result');
  }

  // ---------- Knoppen ----------
  $$('[data-level]').forEach(function (b) { b.addEventListener('click', function () { start(parseInt(b.dataset.level, 10)); }); });
  $('[data-next]').addEventListener('click', function () {
    state.i++;
    if (state.i < state.round.length) ask(); else result();
  });
  $('[data-retry]').addEventListener('click', function () { start(state.level); });
  $('[data-home]').addEventListener('click', function () { show('levels'); });
  renderBest();
})();
